import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  HostListener,
  ElementRef,
  Renderer2,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../core/notification.service';
import { Router, RouterLink, RouterLinkActive, RouterModule, ActivatedRoute, NavigationEnd } from '@angular/router';
import { StorageService } from '../../core/storage.service';
import {MatIconModule } from '@angular/material/icon';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MenuService } from '../services/menu.service';
import { ShareButtonsService } from '../services/share-buttons.service';
import { MetaService } from '../services/meta.service';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterLink,
    RouterLinkActive,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input() dataContent: string = '';
  @Input() profileExists: boolean = true;
  @Output() saveData = new EventEmitter();
  @Output() categorySelected = new EventEmitter<string>();

  // Search functionality
  searchQuery: string = '';
  isSearching: boolean = false;

  // Mobile search functionality
  showMobileSearch: boolean = false;
  mobileSearchQuery: string = '';

  // Sticky header functionality
  isSticky: boolean = false;
  lastScrollTop: number = 0;
isHeaderVisible: boolean = true;
  scrollThreshold: number = 5; // Minimum scroll distance to trigger header hide/show
  hideHeaderThreshold: number = 150; // Scroll distance before hiding header
  showHeaderThreshold: number = 100; // Scroll distance before showing header
  private scrollTimeout: any = null;
  public filteredMenuItems: any[] = [];
  public moreMenuItems: any[] = [];

  subMenus: { [key: string]: any } = {};
  public isMobileMenuOpen: boolean = false;
  private isToggling: boolean = false;

  public buttons: any = [
    { name: 'Log in', route: 'auth/login' },
    { name: 'Sign up', route: 'auth/signup' },
  ];

  // Removed static menu properties - using dynamic menu only
  searchForm: any;
  permissions: any = [];
  public interviewCategories: any[] = [];
  googleFormUrl: string = 'https://docs.google.com/forms/d/e/1FAIpQLSfb2g3dZeLeWIE2tsEZ4Y7GUQ4rMZpNvtZ0xgsdv3KAq2ZRCQ/viewform';
  reLoader: boolean = false;
  public socialMediaLinks = {
    linkedin: 'https://www.linkedin.com/company/superlawyer/',
    website: 'https://www.superlawyer.in',
    instagram: 'https://www.instagram.com/super.lawyer/',
    youtube: 'https://www.youtube.com/channel/UCIdU1fAe1gmPguWuVStcPpg'
  };
  readonly subs: Subscription[] = [];
  public activeInterviewCategory: any = null;

  public showNationalSubmenu = false;
  public showInterviewMenu = false;
  showContactPopup: boolean = false;
  public showMoreMenu = false;

  // Enhanced share buttons properties (matching other components)
  shareButtonsHtml: string = '';
  isLoadingShareButtons: boolean = false;
  socialShareUrls: any = {};

  constructor(
    readonly router: Router,
    private activatedRoute: ActivatedRoute,
    public storage: StorageService,
    readonly dialog: MatDialog,
    private readonly notificationService: NotificationService,
    private elementRef: ElementRef,
    private menuService: MenuService,
    private renderer: Renderer2,
    private shareButtonsService: ShareButtonsService,
    private metaService: MetaService,
    private title: Title,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    let allPermissions = JSON.parse(
      this.storage.retrieveFromLocal('permissions')
    );

    allPermissions?.forEach((permission: any) => {
      if (
        permission.mapping_status === '1' &&
        (permission.permission_name.includes('view') ||
          permission.permission_name.includes('list') ||
          permission.permission_name.includes('details'))
      ) {
        this.permissions.push(permission.permission_name);

        // Check for submenu permissions
        if (permission.submenu && permission.submenu.length > 0) {
          permission.submenu.forEach((subPermission: any) => {
            if (
              subPermission.mapping_status === '1' &&
              (subPermission.permission_name.includes('view') ||
                subPermission.permission_name.includes('list') ||
                subPermission.permission_name.includes('details'))
            ) {
              this.permissions.push(subPermission.permission_name);
            }
          });
        }
      }
    });

    // Initial setup for social sharing (runs once on component load)
    this.setSocialMetaTags();
    this.generateSocialShareUrls();
    this.loadShareButtons();

    // Simple subscription to just update search input from URL parameters
    this.subs.push(
      this.activatedRoute.queryParams.subscribe(params => {
        if (params['search']) {
          this.searchQuery = params['search'];
        }
      })
    );

    // Separate subscription for navigation events (without search query updates)
    this.subs.push(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.closeMobileNavbar();
      })
    );

    // Defer HTTP calls to prevent ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.headerContent();
      // Remove duplicate social sharing calls - handled in router subscription
    }, 0);

    // Listen to router events to close mobile navbar on navigation and update sharing
    this.subs.push(
      this.router.events.subscribe(() => {
        this.closeMobileNavbar();
        // Keep mobile search open on navigation as per user request
        // Update social sharing when route changes
        setTimeout(() => {
          this.setSocialMetaTags();
          this.generateSocialShareUrls();
          this.loadShareButtons();
        }, 100);
      })
    );

    // Listen for Bootstrap collapse events to update mobile menu state
    if (isPlatformBrowser(this.platformId)) {
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    if (navbarCollapse) {
      navbarCollapse.addEventListener('shown.bs.collapse', () => {
        this.isMobileMenuOpen = true;
        // Prevent body scroll when mobile menu is open
        document.body.classList.add('mobile-menu-open');
      });

      navbarCollapse.addEventListener('hidden.bs.collapse', () => {
        this.isMobileMenuOpen = false;
        // Re-enable body scroll when mobile menu is closed
        document.body.classList.remove('mobile-menu-open');
      });
      }
    }
  }

      // Sticky header scroll handler
  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.handleScroll();
  }
  private handleScroll(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const isScrollingDown = scrollTop > this.lastScrollTop;
    const isScrollingUp = scrollTop < this.lastScrollTop;

    if (scrollTop > 50) {
      this.isSticky = true;
      document.body.classList.add('sticky-header-active');
      document.body.classList.remove('header-hidden');

      if (isScrollingDown) {
        this.isHeaderVisible = false; // Hide when scrolling down
      } else if (isScrollingUp) {
        this.isHeaderVisible = true; // Show when scrolling up
      }
    } else {
      this.isSticky = false;
      this.isHeaderVisible = true;
      document.body.classList.remove('sticky-header-active');
      document.body.classList.add('header-hidden');
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }


  // Set social meta tags based on current route (matching other components pattern)
  setSocialMetaTags(): void {
    const currentRoute = this.router.url;
    console.log('🔍 Header.setSocialMetaTags called for route:', currentRoute);
    
    // Skip setting meta tags for interview detail pages - let the component handle it
    // Interview detail pages are direct slugs (not under /interviews/ path)
    if (currentRoute !== '/' && 
        !currentRoute.includes('/about-us') && 
        !currentRoute.includes('/recommend-an-interview') && 
        !currentRoute.includes('/youtube-channel') && 
        !currentRoute.includes('/search-results') && 
        !currentRoute.includes('/interviews/')) {
      // This is likely an interview detail page, skip setting meta tags
      console.log('🚫 Header: Skipping meta tags for interview detail page:', currentRoute);
      return;
    }
    
    console.log('✅ Header: Setting meta tags for route:', currentRoute);
    
    const baseUrl = (environment as any).frontendUrl || (isPlatformBrowser(this.platformId) ? window.location.origin : 'https://superlawyer.in');
    const currentUrl = isPlatformBrowser(this.platformId) ? window.location.href : `${baseUrl}${currentRoute}`;

    // Dynamic title, description, and image based on current route
    let title = 'SuperLawyer - Legal Interviews and Career Insights';
    let description = 'Discover exclusive legal interviews, career guidance, and insights from top legal professionals.';
    let type = 'website';

    if (currentRoute.includes('/about-us')) {
      title = 'Learn about SuperLawyer - Democratizing Legal Interviews';
      description = 'Learn about SuperLawyer mission to democratize legal interviews and provide career insights for legal professionals.';
    } else if (currentRoute.includes('/recommend-an-interview')) {
      title = 'Connect with SuperLawyer - Suggest an Interview';
      description = 'Get in touch with SuperLawyer for legal consultation, career guidance, and expert advice. Contact our team for professional legal support.';
    } else if (currentRoute.includes('/youtube-channel')) {
      title = 'Watch legal insights on SuperLawyer YouTube Channel';
      description = 'Watch exclusive legal interviews and insights on our YouTube channel. Subscribe for regular legal career guidance.';
    } else if (currentRoute.includes('/interview/')) {
      title = 'Legal Interviews - SuperLawyer';
      description = 'Explore comprehensive legal interviews and career guidance from top legal professionals and industry experts.';
      type = 'article';
    } else if (currentRoute.includes('/search-results')) {
      title = 'Search Results - SuperLawyer';
      description = 'Find legal interviews and insights on SuperLawyer platform. Search through our comprehensive collection of legal resources.';
    }

    const image = `${baseUrl}/images/logo.svg`;

    this.metaService.setSocialMetaTags({
      title,
      description,
      image,
      url: currentUrl,
      type,
      siteName: 'SuperLawyer',
      author: 'SuperLawyer Team'
    });
  }

  // Generate social share URLs (matching other components pattern)
  generateSocialShareUrls(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const currentRoute = this.router.url;
    const baseUrl = (environment as any).frontendUrl || (isPlatformBrowser(this.platformId) ? window.location.origin : 'https://superlawyer.in');
    const currentUrl = isPlatformBrowser(this.platformId) ? window.location.href : `${baseUrl}${this.router.url}`;

    // Dynamic title and description based on current route
    let title = 'SuperLawyer - Legal Interviews and Career Insights';
    let description = 'Discover exclusive legal interviews, career guidance, and insights from top legal professionals.';

    if (currentRoute.includes('/about-us')) {
      title = 'Learn about SuperLawyer - Democratizing Legal Interviews';
      description = 'Learn about SuperLawyer mission to democratize legal interviews and provide career insights.';
    } else if (currentRoute.includes('/recommend-an-interview')) {
      title = 'Connect with SuperLawyer - Suggest an Interview';
      description = 'Get in touch with SuperLawyer for legal consultation, career guidance, and expert advice.';
    } else if (currentRoute.includes('/youtube-channel')) {
      title = 'Watch legal insights on SuperLawyer YouTube Channel';
      description = 'Watch exclusive legal interviews and insights on our YouTube channel.';
    } else if (currentRoute.includes('/interviews/')) {
      title = 'Check out these amazing legal interviews on SuperLawyer!';
      description = 'Explore comprehensive legal interviews and career guidance from top legal professionals.';
    } else if (currentRoute.includes('/search-results')) {
      title = 'Search Results - SuperLawyer';
      description = 'Find legal interviews and insights on SuperLawyer platform.';
    }

    const encodedTitle = encodeURIComponent(title);
    const encodedUrl = encodeURIComponent(currentUrl);
    const encodedImage = encodeURIComponent(`${baseUrl}/images/logo.svg`);
    const encodedDescription = encodeURIComponent(description);

    // Enhanced social sharing URLs with better parameters
    this.socialShareUrls = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedTitle}%20-%20${encodedDescription}&picture=${encodedImage}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}&via=SuperLawyer`,
      linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}&summary=${encodedDescription}&source=SuperLawyer`,
      instagram: `https://www.instagram.com/share?url=${encodedUrl}&caption=${encodedTitle}%20-%20${encodedDescription}`,
      whatsapp: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      email: `mailto:?subject=${encodedTitle}&body=${encodedDescription}%20${encodedUrl}`
    };

  }

  // Share functionality (matching other components pattern)
  sharePost(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const currentRoute = this.router.url;
    const currentUrl = isPlatformBrowser(this.platformId) ? window.location.href : `${(environment as any).frontendUrl || 'https://superlawyer.in'}${currentRoute}`;

    // Get current meta tags from MetaService (set by each page component)
    const currentTitle = this.title.getTitle();
    const currentOgTitle = this.meta.getTag('property="og:title"')?.content;
    const currentOgDescription = this.meta.getTag('property="og:description"')?.content;
    const currentOgImage = this.meta.getTag('property="og:image"')?.content;
    
    // Use current meta tags if available, otherwise fallback to defaults
    let title = currentOgTitle || currentTitle || 'SuperLawyer - Legal Interviews and Career Insights';
    let description = currentOgDescription || 'Discover exclusive legal interviews, career guidance, and insights from top legal professionals.';
    let image = currentOgImage || '/images/logo.svg';

    // Set the correct meta tags for sharing
    this.metaService.setSocialMetaTags({
      title,
      description,
      image,
      url: currentUrl,
      type: 'website',
      siteName: 'SuperLawyer',
      author: 'SuperLawyer Team'
    });

    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: description,
          url: currentUrl,
        })
        .catch((err) => console.log('Error sharing:', err));
    } else if (navigator.clipboard) {
      // Fallback: copy URL to clipboard
      navigator.clipboard.writeText(currentUrl).then(() => {
        this.notificationService.successNotification(
          'Link copied to clipboard!'
        );
      }).catch(() => {
        // Final fallback: show share modal or notification
        this.notificationService.successNotification(
          `Share this page: ${currentUrl}`
        );
      });
    } else {
      // Final fallback: show share modal or notification
      this.notificationService.successNotification(
        `Share this page: ${currentUrl}`
      );
    }
  }

  // Add encodeURIComponent as a method for template use
  encodeURIComponent(str: string): string {
    return encodeURIComponent(str);
  }

  // Strip HTML for display (matching other components pattern)
  stripHtml(html: string): string {
    if (!isPlatformBrowser(this.platformId)) {
      // Server-side: Use simple regex to strip HTML tags
      return html.replace(/<[^>]*>/g, '').replace(/&[^;]+;/g, ' ').trim();
    }

    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

    // Search functionality
  onSearch(): void {
    if (this.searchQuery.trim()) {
      this.isSearching = true;
      // Navigate to search results page
      this.router.navigate(['/search'], {
        queryParams: { search: this.searchQuery.trim() }
      }).then(() => {
        // Reset searching state after navigation
        setTimeout(() => {
          this.isSearching = false;
        }, 500);
      });
      this.closeMobileNavbar();
    }
  }

    // Handle search input changes (for detecting when cross is clicked)
  onSearchChange(event: any): void {
    this.searchQuery = event.target.value;

    // If search is cleared (cross button clicked), go to home page
    if (!this.searchQuery || this.searchQuery.trim() === '') {
      this.isSearching = false;
      this.router.navigate(['/']);
    }
  }

  // Clear search input and refresh page to show all data
  clearSearch(): void {
    this.searchQuery = '';
    this.isSearching = false;
    this.closeMobileNavbar();

    // Refresh the page to show all fresh data
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = '/';
    } else {
      this.router.navigate(['/']);
    }
  }

  // Mobile search functionality
  toggleMobileSearch(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.showMobileSearch = !this.showMobileSearch;

    // Close other dropdowns when opening mobile search (but not mobile menu)
    if (this.showMobileSearch) {
      this.showInterviewMenu = false;
      this.activeInterviewCategory = null;
      this.showContactPopup = false;
      this.showMoreMenu = false;

      // Focus on mobile search input after a short delay to ensure it's rendered
      setTimeout(() => {
        if (isPlatformBrowser(this.platformId)) {
          const mobileSearchInput = document.getElementById('mobileSearchInput') as HTMLInputElement;
          if (mobileSearchInput) {
            mobileSearchInput.focus();
          }
        }
      }, 100);
    } else {
      this.mobileSearchQuery = '';
    }
  }

  closeMobileSearch(): void {
    this.showMobileSearch = false;
    this.mobileSearchQuery = '';
  }

  onMobileSearch(): void {
    if (this.mobileSearchQuery.trim()) {
      this.isSearching = true;
      // Navigate to search results page
      this.router.navigate(['/search'], {
        queryParams: { search: this.mobileSearchQuery.trim() }
      }).then(() => {
        // Reset searching state but keep mobile search open
        setTimeout(() => {
          this.isSearching = false;
          this.closeMobileNavbar(); // Close mobile menu if open, but keep search visible
        }, 500);
      });
    }
  }

  onMobileSearchChange(event: any): void {
    this.mobileSearchQuery = event.target.value;

    // Reset searching state when input is cleared, but don't navigate
    if (!this.mobileSearchQuery || this.mobileSearchQuery.trim() === '') {
      this.isSearching = false;
    }
  }

  // Method to clear search and refresh page to show all data (used by close button)
  clearMobileSearch(): void {
    this.mobileSearchQuery = '';
    this.isSearching = false;
    this.closeMobileSearch();

    // Refresh the page to show all fresh data
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = '/';
    } else {
      this.router.navigate(['/']);
    }
  }


  // setSubMenuRef(key: string, ref: MatMenu): void {
  //   if (!this.subMenus[key]) {
  //     this.subMenus[key] = ref;
  //   }
  // }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  /**
   * Handles the mobile menu toggle button click
   */
  onMobileMenuToggle(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Prevent multiple rapid clicks
    if (this.isToggling) {
      return;
    }

    this.isToggling = true;

    const navbarCollapse = document.getElementById('navbarSupportedContent');
    if (navbarCollapse) {
      if (navbarCollapse.classList.contains('show')) {
        // Menu is open, close it
        this.closeMobileNavbar();
      } else {
        // Menu is closed, open it
        this.isMobileMenuOpen = true;
        // Let Bootstrap handle the opening
      }
    }

    // Reset toggle flag after animation completes
    setTimeout(() => {
      this.isToggling = false;
    }, 350); // Slightly longer than the CSS transition
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Don't close dropdowns if clicking on mobile menu toggle button or mobile search toggle
    if (target && (
      target.closest('.navbar-toggler') ||
      target.closest('.mobile-search-toggle') ||
      target.closest('.mobile-search-container') ||
      target.closest('#navbarSupportedContent')
    )) {
      return;
    }

    // Check if click is outside the dropdown area
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // Only close dropdowns, not the mobile menu
      this.showInterviewMenu = false;
      this.activeInterviewCategory = null;
      this.showContactPopup = false;
      this.showMoreMenu = false;
      this.showMobileSearch = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any): void {
    // Close mobile menu on window resize to desktop
    if (event.target.innerWidth >= 992) { // Bootstrap lg breakpoint
      this.closeMobileNavbar();
    }
  }

  closeAllDropdowns(closeMobileNavbar: boolean = true): void {
    this.showInterviewMenu = false;
    this.activeInterviewCategory = null;
    this.showContactPopup = false;
    this.showMoreMenu = false;
    this.showMobileSearch = false;

    if (closeMobileNavbar) {
      this.closeMobileNavbar();
    }
  }

  /**
   * Closes the Bootstrap navbar collapse on mobile
   */
  closeMobileNavbar(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Get the navbar collapse element
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      // Remove the 'show' class to close the navbar
      this.renderer.removeClass(navbarCollapse, 'show');

      // Also update the aria-expanded attribute on the toggle button
      const toggleButton = document.querySelector('[data-bs-toggle="collapse"]') as HTMLElement;
      if (toggleButton) {
        this.renderer.setAttribute(toggleButton, 'aria-expanded', 'false');
      }

      // If Bootstrap is available, also trigger the collapse method
      if (typeof (window as any).bootstrap !== 'undefined') {
        const bsCollapse = new (window as any).bootstrap.Collapse(navbarCollapse, {
          toggle: false
        });
        bsCollapse.hide();
      }
    }
    this.isMobileMenuOpen = false;

    // Re-enable body scroll
    document.body.classList.remove('mobile-menu-open');
  }

  /**
   * Checks if mobile menu is currently open
   */
  isMobileMenuOpenState(): boolean {
    if (isPlatformBrowser(this.platformId)) {
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    return navbarCollapse ? navbarCollapse.classList.contains('show') : false;
    }
    return false;
  }

  toggleInterviewMenu(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.showInterviewMenu = !this.showInterviewMenu;

    // Default to National submenu when opening
    if (this.showInterviewMenu) {
      const interviewsMenu = this.filteredMenuItems.find((item: any) => item.title === 'Interviews');
      if (interviewsMenu?.submenu && interviewsMenu.submenu.length > 0) {
        this.activeInterviewCategory = interviewsMenu.submenu[0]; // National
      }
    } else {
      this.activeInterviewCategory = null;
    }
  }

  toggleInterviewSubmenu(category: any, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    this.activeInterviewCategory =
      this.activeInterviewCategory === category ? null : category;
  }

  toggleContactPopup(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.showContactPopup = !this.showContactPopup;
    // Close other dropdowns
    this.showInterviewMenu = false;
    this.activeInterviewCategory = null;
  }

  toggleMoreMenu(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.showMoreMenu = !this.showMoreMenu;
    // Close other dropdowns
    this.showInterviewMenu = false;
    this.activeInterviewCategory = null;
    this.showContactPopup = false;
  }

  closeContactPopup(): void {
    this.showContactPopup = false;
    this.closeMobileNavbar();
  }

  openInterviewMenu(): void {
    // Only work on desktop (hover doesn't work on mobile anyway)
    if (!this.isMobileView()) {
      this.showInterviewMenu = true;
      this.showMoreMenu = false;

      // Set default active category to show children immediately
      const interviewsMenu = this.filteredMenuItems.find((item: any) => item.title === 'Interviews');
      if (interviewsMenu?.submenu && interviewsMenu.submenu.length > 0) {
        this.activeInterviewCategory = interviewsMenu.submenu[0]; // Default to first category (National)
      }
    }
  }

  closeInterviewMenu(): void {
    // Only work on desktop
    if (!this.isMobileView()) {
      this.showInterviewMenu = false;
    }
  }

  openMoreMenu(): void {
    // Only work on desktop
    if (!this.isMobileView()) {
      this.showMoreMenu = true;
      this.showInterviewMenu = false;
    }
  }

  closeMoreMenu(): void {
    // Only work on desktop
    if (!this.isMobileView()) {
      this.showMoreMenu = false;
    }
  }

  openContactPopup(): void {
    this.showContactPopup = true;
  }

  headerContent() {
    // Load only dynamic menu from WordPress API
    this.subs.push(
      this.menuService.getPrimaryMenu().subscribe({
        next: (dynamicMenuItems) => {
          if (dynamicMenuItems && dynamicMenuItems.length > 0) {
            // Use only dynamic menu items
            // Find index of Youtube Channel
            const youtubeIndex = dynamicMenuItems.findIndex((item: any) => item.title.toLowerCase().includes('youtube'));
            // The last three menus (after Youtube Channel)
            const moreMenusStart = youtubeIndex >= 0 ? youtubeIndex + 1 : dynamicMenuItems.length - 3;
            const moreMenus = dynamicMenuItems.slice(moreMenusStart);
            // Remove these from main menu
            const mainMenus = dynamicMenuItems.slice(0, moreMenusStart);
            // Add 'More' dropdown after Youtube Channel
            if (moreMenus.length > 0) {
              this.moreMenuItems = moreMenus;
              mainMenus.push({
                title: 'More',
                submenu: moreMenus,
                isMoreDropdown: true
              });
            } else {
              this.moreMenuItems = [];
            }
            this.filteredMenuItems = mainMenus;
            // Set National as default active category to show submenu immediately
            const interviewsMenu = mainMenus.find((item: any) => item.title === 'Interviews');
            if (interviewsMenu?.submenu && interviewsMenu.submenu.length > 0) {
              this.activeInterviewCategory = interviewsMenu.submenu[0]; // Default to National
            }
          } else {
            this.filteredMenuItems = [];
            this.moreMenuItems = [];
          }
        },
        error: (error) => {
          this.filteredMenuItems = [];
          this.moreMenuItems = [];
        }
      })
    );
  }


  isSelected(route: string): boolean {
    if (route == '/home') {
      return false;
    }
    return this.router.url.includes(route);
  }

  onCategorySelect(item: any, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    // Check if this is a subcategory (has a parent category)
    if (this.activeInterviewCategory && this.activeInterviewCategory !== item) {
      // This is a subcategory, navigate with full path
      const categorySlug = (this.activeInterviewCategory.slug || this.activeInterviewCategory.title || this.activeInterviewCategory.category).toLowerCase().replace(/\s+/g, '-');
      const subcategorySlug = (item.slug || item.title || item.category).toLowerCase().replace(/\s+/g, '-');
      this.router.navigate(['/interviews', categorySlug, subcategorySlug]);
      this.categorySelected.emit(`${categorySlug}/${subcategorySlug}`);
    } else {
      // This is a main category, navigate to category level
      const slug = (item.slug || item.title || item.category).toLowerCase().replace(/\s+/g, '-');
      this.router.navigate(['/interviews', slug]);
      this.categorySelected.emit(slug);
    }

    // Close dropdowns after navigation logic
    this.closeAllDropdowns();
  }

  /**
   * Load share buttons from API with enhanced dynamic content based on current page
   */
  loadShareButtons(): void {
    this.isLoadingShareButtons = true;

    this.subs.push(
      this.shareButtonsService.getShareButtons().subscribe({
        next: (response: any) => {
          if (response && response.html) {
            // Get current route and customize share content
            const currentRoute = this.router.url;
            const baseUrl = (environment as any).frontendUrl || (isPlatformBrowser(this.platformId) ? window.location.origin : 'https://superlawyer.in');
            const currentUrl = isPlatformBrowser(this.platformId) ? window.location.href : `${baseUrl}${this.router.url}`;

            // Dynamic title based on current page (matching generateSocialShareUrls)
            let title = 'SuperLawyer - Legal Interviews and Career Insights';

            if (currentRoute.includes('/about-us')) {
              title = 'Learn about SuperLawyer - Democratizing Legal Interviews';
            } else if (currentRoute.includes('/recommend-an-interview')) {
              title = 'Connect with SuperLawyer - Suggest an Interview';
            } else if (currentRoute.includes('/youtube-channel')) {
              title = 'Watch legal insights on SuperLawyer YouTube Channel';
            } else if (currentRoute.includes('/interviews/')) {
              title = 'Check out these amazing legal interviews on SuperLawyer!';
            } else if (currentRoute.includes('/search-results')) {
              title = 'Search Results - SuperLawyer';
            }

            // Inject dynamic data into share buttons
            this.shareButtonsHtml = this.shareButtonsService.injectDataIntoShareButtons(
              response.html,
              title,
              currentUrl
            );
          }
          this.isLoadingShareButtons = false;
        },
        error: (error: any) => {
          this.isLoadingShareButtons = false;
        }
      })
    );
  }

  shareToInstagram(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const currentRoute = this.router.url;
    const baseUrl = (environment as any).frontendUrl || (isPlatformBrowser(this.platformId) ? window.location.origin : 'https://superlawyer.in');
    const currentUrl = isPlatformBrowser(this.platformId) ? window.location.href : `${(environment as any).frontendUrl || 'https://superlawyer.in'}${this.router.url}`;

    // Dynamic title and description based on current route
    let title = 'SuperLawyer - Legal Interviews and Career Insights';
    let description = 'Discover exclusive legal interviews, career guidance, and insights from top legal professionals.';

    if (currentRoute.includes('/about-us')) {
      title = 'Learn about SuperLawyer - Democratizing Legal Interviews';
      description = 'Learn about SuperLawyer mission to democratize legal interviews and provide career insights.';
    } else if (currentRoute.includes('/recommend-an-interview')) {
      title = 'Connect with SuperLawyer - Suggest an Interview';
      description = 'Get in touch with SuperLawyer for legal consultation, career guidance, and expert advice.';
    } else if (currentRoute.includes('/youtube-channel')) {
      title = 'Watch legal insights on SuperLawyer YouTube Channel';
      description = 'Watch exclusive legal interviews and insights on our YouTube channel.';
    } else if (currentRoute.includes('/interviews/')) {
      title = 'Check out these amazing legal interviews on SuperLawyer!';
      description = 'Explore comprehensive legal interviews and career guidance from top legal professionals.';
    } else if (currentRoute.includes('/search-results')) {
      title = 'Search Results - SuperLawyer';
      description = 'Find legal interviews and insights on SuperLawyer platform.';
    }

    // Create Instagram-friendly content
    const instagramText = `${title}\n\n${description}\n\nCheck it out:\n${currentUrl}`;

    // Copy content to clipboard
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(instagramText).then(() => {
        this.notificationService.successNotification(
          '📋 Copied to clipboard! Open Instagram and share.'
        );
      }).catch((error) => {
        console.error('Failed to copy to clipboard:', error);
        this.notificationService.successNotification(
          '📋 Copy this content to Instagram:\n\n' + instagramText
        );
      });
    } else {
      // Fallback for browsers without clipboard API
      this.notificationService.successNotification(
        '📋 Copy this content to Instagram:\n\n' + instagramText
      );
    }
  }

  // Mobile-specific toggle methods
  toggleInterviewMenuMobile(event: Event): void {
    if (this.isMobileView()) {
      const target = event.target as HTMLElement;

      // Only handle clicks on the menu title itself, not on dropdown content
      if (target.closest('.nav-link') || target.closest('.interview-dropdown-container')) {
        // If clicking on dropdown content, don't toggle the menu
        if (target.closest('.interview-dropdown-container')) {
          return;
        }
      }
      event.preventDefault();
      event.stopPropagation();
      this.showInterviewMenu = !this.showInterviewMenu;

      // Set default active category when opening
      if (this.showInterviewMenu) {
        const interviewsMenu = this.filteredMenuItems.find((item: any) => item.title === 'Interviews');
        if (interviewsMenu?.submenu && interviewsMenu.submenu.length > 0) {
          this.activeInterviewCategory = interviewsMenu.submenu[0];
        }
        // Close other menus
        this.showMoreMenu = false;
        this.showContactPopup = false;
        this.showMobileSearch = false;
      } else {
        this.activeInterviewCategory = null;
      }
    }
  }

  toggleMoreMenuMobile(event: Event): void {
    if (this.isMobileView()) {
      const target = event.target as HTMLElement;

      // Only handle clicks on the menu title itself, not on dropdown content
      if (target.closest('.nav-link') || target.closest('.interview-dropdown-container')) {
        // If clicking on dropdown content, don't toggle the menu
        if (target.closest('.interview-dropdown-container')) {
          return;
        }
      }
      event.preventDefault();
      event.stopPropagation();
      this.showMoreMenu = !this.showMoreMenu;

      if (this.showMoreMenu) {
        // Close other menus
        this.showInterviewMenu = false;
        this.activeInterviewCategory = null;
        this.showContactPopup = false;
        this.showMobileSearch = false;
      }
    }
  }

  // Helper method to detect mobile view
  private isMobileView(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    return isPlatformBrowser(this.platformId) ? window.innerWidth < 992 : false; // Bootstrap lg breakpoint
  }

  ngOnDestroy(): void {
    this.subs.forEach((el: any) => el.unsubscribe());
// Clear scroll timeout
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    // Clean up body class when component is destroyed
    if (isPlatformBrowser(this.platformId)) {
     document.body.classList.remove('header-hidden');
    }
  }
}

